<template>
    <div class="list-info">
        <div class="study-radio" v-if="mode!='topic'">
            <el-radio-group v-model="studyRadio" size="mini" @change="changeRadio">
                <el-radio-button v-for="item in radioList" :key="item.label" :label="item.label">{{ item.value }}</el-radio-button>
            </el-radio-group>
        </div>
        <ul>
            <li class="info" v-for="(item, index) in studyListInfo" :key="index">
                <a>
                    <div class="info-txt">
                        <div class="txt-tit">{{ item.firstClassification }}</div>
                        <div class="sublevel-txt">
                            <span
                                v-for="(sublevel, num) in sublevelSlice(item)"
                                :key="num"
                                @click="toPage(item, 'page', sublevel)"
                            >
                                {{ sublevelLabel(sublevel) }}
                            </span>
                        </div>
                    </div>
                </a>
            </li>
        </ul>
        <div v-if="studyListInfo && studyListInfo.length != 0" class="look-more" @click="toPage(studyListInfo, 'more')">查看更多</div>
    </div>
</template>

<script>
import { clinicList,topicList } from '../../../../io/api'

// 临床：1 临床指南 2 名医经验
const CLINIC_RADIO = [
    { label: '1', value: '临床指南' },
    { label: '2', value: '名医经验' },
]
// 中医：3 方剂医案 4 中药课堂 5 常用中成药
const TCM_RADIO = [
    { label: '3', value: '方剂医案' },
    { label: '4', value: '中药课堂' },
    { label: '5', value: '常用中成药' },
]

export default {
    components: {},
    props: {
        // 'clinic' | 'tcm'，决定 tab 和接口 type
        mode: {
            type: String,
            default: 'clinic',
            validator: (v) => ['clinic', 'tcm','topic'].includes(v),
        },
    },
    data() {
        const isClinic = this.mode === 'clinic'
        return {
            studyListInfo: [],
            studyRadio: isClinic ? '1' : '3',
            listMap: {}, // 按 subType 缓存列表 { '1': [], '2': [] } 或 { '3': [], '4': [], '5': [] }
        }
    },
    computed: {
        radioList() {
            return this.mode === 'clinic' ? CLINIC_RADIO : TCM_RADIO
        },
        apiType() {
            return this.mode === 'clinic' ? 1 : 2
        },
    },
    watch: {
        mode: {
            immediate: true,
            handler() {
                const isClinic = this.mode === 'clinic'
                this.studyRadio = isClinic ? '1' : '3'
                this.listMap = {}
                this.studyListInfo = []
            },
        },
    },
    mounted() {
        if (this.mode === 'clinic') {
            this.getList(1)
            this.getList(2)
        } else if(this.mode === 'tcm'){
            this.getList(3)
            this.getList(4)
            this.getList(5)
        }else if(this.mode==='topic'){
            this.getTopic()
        }
    },
    methods: {
        sublevelSlice(item) {
            const list = item.secondClassificationMapList || item.secondClassificationList || []
            return list.slice(0, 8)
        },
        sublevelLabel(sublevel) {
            return (sublevel && sublevel.label) ? sublevel.label : (sublevel || '')
        },
        getList(subType) {
            const params = {
                page: 1,
                limit: 6,
                type: this.apiType,
                subType: subType || this.studyRadio,
            }
            clinicList(params).then((res) => {
                const { code, data, msg } = res.data
                if (code == 0) {
                    const list = data.list || []
                    this.$set(this.listMap, String(subType), list)
                    if (String(subType) === this.studyRadio) {
                        this.studyListInfo = list
                    }
                } else {
                    this.$message.error(msg || '请求失败～')
                }
            })
        },
        //题库
        getTopic(){
            let params = {
                page: 1,
                limit: 6, 
            }
            topicList(params).then(res=>{
                const { code, data, msg } = res.data
                if (code == 0) {
                    const list = data.list || []
                    this.studyListInfo = list
                } else {
                    this.$message.error(msg || '请求失败～')
                }
            })
        },
        changeRadio(val) {
            this.studyRadio = val
            this.studyListInfo = this.listMap[String(val)] || []
        },
        toPage(item, type, list) {
            let path = 'studyMore'
            const query = {
                subType: this.mode=='topic'?this.mode:this.studyRadio,
                changeflag: 3,
            } 
                
            if (type == 'page') {
                if (list && list.type == 'link') {
                    window.open(list.url, '_blank')
                    return
                }
                if(this.mode=='topic'){
                    path = 'detailsTopic' 
                    query.firstClassification = item.firstClassification
                    query.secondClassification = (list && list.label) ? list.label : (list || '')
                } else {
                    path = 'studyDetails'
                    query.firstClassification = item.firstClassification
                    query.secondClassification = (list && list.label) ? list.label : (list || '')
                }
            }
            const url = this.$router.resolve({ path, query })
            this.$windowOpen({ url: url.href, isLogin: true })
        },
    },
}
</script>

<style lang="less" scoped>
@import url('./study.less');
</style>
